import { Divider, Group, Stack, Text } from '@mantine/core';
import dayjs from 'dayjs';
import { i18nKeys, useTranslation } from 'locales';
import Amount from 'shared/components/Amount';

import { useInvoiceFormContext } from '../InvoiceForm.context';
import { useInvoiceFormTotals } from '../InvoiceForm.hooks';
import type { InvoiceFormSharedProps } from '../InvoiceForm.types';

type TotalsDetailsProps = InvoiceFormSharedProps;

export const TotalsDetails = ({ currency }: TotalsDetailsProps) => {
  const { t } = useTranslation();

  const form = useInvoiceFormContext();

  const { totalTvac, totalHtva, totalVat, totalDiscount } = useInvoiceFormTotals();

  const dueDate = form.values.due_date;
  return (
    <Stack gap="xs" miw="40%">
      <Group justify="space-between" gap="xs">
        <Text size="sm">{t(i18nKeys.TOTAL_NOT_VAT_PRICE)} :</Text>
        <Text span size="sm">
          <Amount value={totalHtva} suffix={currency} />
        </Text>
      </Group>
      <Group justify="space-between" gap="xs">
        <Text size="sm">{t(i18nKeys.VAT)} :</Text>
        <Text span size="sm">
          <Amount value={totalVat} suffix={currency} />
        </Text>
      </Group>
      <Divider my={4} />
      <Group justify="space-between" gap="xs">
        <Text size="lg" fw={700}>
          {t(i18nKeys.TOTAL_VAT_PRICE)} :
        </Text>
        <Text span size="lg" fw={700}>
          <Amount value={totalTvac} suffix={currency} />
        </Text>
      </Group>
      <Group justify="space-between" gap="xs">
        <Text size="sm">{t(i18nKeys.INVOICE.DISCOUNT)} :</Text>
        <Text span size="sm">
          <Amount value={totalDiscount} suffix={currency} />
        </Text>
      </Group>
      {dueDate && (
        <Group justify="space-between" gap="xs">
          <Text size="sm">{t(i18nKeys.DUE_DATE)} :</Text>
          <Text size="sm">{dayjs(dueDate).format('L')}</Text>
        </Group>
      )}
    </Stack>
  );
};
